import React from "react";
import HtmlInput from "./input";

const FormHtmlInput = (props) => {
    const { form, data, autoFocus, onKeyDown } = props;
    const formikValue = form.values[data.name] ?? "";
    const touched = form.touched[data.name] ?? false;
    const error = form.errors[data.name] ?? "";
    return (
        <HtmlInput
            onChange={form.handleChange}
            onBlur={form.handleBlur}
            autoFocus={autoFocus}
            onKeyDown={onKeyDown}
            {...data}
            value={formikValue}
            error={touched && error}
        />
    );
};

export default FormHtmlInput;
